import BENEFICIARY_SUBJECT_TYPE_KEY from '@Domain/Subjects/BeneficiarySubjectTypeKey';
import buildSubjectListPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectListPath';
import Container from '@Guidelines/Component/Container';
import DocumentListContent from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/DocumentListContent';
import DocumentsNotifications from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentsNotifications';
import SubjectBreadcrumb from '@UI/Pages/Beneficiaries/Shared/SubjectBreadcrumb';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import useSubjectAddressParams from '@UI/Pages/Beneficiaries/Hooks/Params/useSubjectAddressParams';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';

const BREADCRUMB_ITEMS = [{ label: 'Documents' }] as const;

/**
 * Mounted from `…/:dossier/documents`. Same validation motif as
 * `DocumentDetails/index.tsx`: an invalid dossier address redirects to the beneficiary list.
 */
const DocumentList: React.FC = () => {
	const navigate = useNavigate();
	const { subject } = useSubjectAddressParams();

	React.useEffect(() => {
		if (subject === null) {
			navigate(buildSubjectListPath(BENEFICIARY_SUBJECT_TYPE_KEY));
		}
	}, [subject, navigate]);

	return (
		<Container>
			<ConditionalLoader data={subject}>
				{(validSubject) => (
					<React.Fragment>
						<SubjectBreadcrumb subject={validSubject} items={BREADCRUMB_ITEMS} />
						<DocumentListContent subject={validSubject} />
					</React.Fragment>
				)}
			</ConditionalLoader>
			<DocumentsNotifications />
		</Container>
	);
};

export default DocumentList;
